import { CFC } from "@api/types/cypress";

const ErrorMessage: CFC<{ message: string }> = ({ message = "" }) => (
  <div className="error">
    <span>{message}</span>
    {/*language=CSS*/}
    <style jsx>{`
      .error span {
        color: red;
      }
    `}</style>
  </div>
);

export default ErrorMessage;
